import React from 'react';

import { PageLayout } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { useFilterStorage, useScreenInfo } from 'src/hooks/common';
import { useCurrentUserVerifier } from 'src/hooks/verifier';
import { useVerifierStaffList } from 'src/hooks/verifierStaff';
import { ResendInviteModal } from 'src/modals/invite';

import { VerifierStaffTableVerifierAdmin } from './VerifierStaffTableVerifierAdmin';

export const VerifierStaffTableWrapperVerifierAdmin: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { pagination } = useFilterStorage();

  const { verifier } = useCurrentUserVerifier();
  const { verifierStaffList, verifierStaffCount, refetch, loading } = useVerifierStaffList(
    verifier?.id,
    undefined,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  if (isMobile) {
    return (
      <React.Fragment>
        <VerifierStaffTableVerifierAdmin
          verifierStaffList={verifierStaffList}
          verifierStaffCount={verifierStaffCount}
          onRefresh={refetchData}
          pagination={pagination}
          loading={loading}
        />

        <ResendInviteModal />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <PageLayout titleContent="Staff" paperSx={pageLayoutPaperSx}>
        <VerifierStaffTableVerifierAdmin
          verifierStaffList={verifierStaffList}
          verifierStaffCount={verifierStaffCount}
          onRefresh={refetchData}
          pagination={pagination}
          loading={loading}
        />
      </PageLayout>

      <ResendInviteModal />
    </React.Fragment>
  );
};
